import { render } from "./ModalComprovante.vue?vue&type=template&id=4bc530a3&ts=true"
import script from "./ModalComprovante.vue?vue&type=script&lang=ts"
export * from "./ModalComprovante.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__